import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { Base_Uri } from '../../Constant/BaseUri';
import { Container, Typography, TextField, Button, Alert, Paper } from '@mui/material';

const ResetPasswordScreen = () => {
    const { token } = useParams();
    const [newPassword, setNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigation = useNavigate()

    const handleResetPassword = async () => {
        try {
            const response = await axios.post(`${Base_Uri}reset-password`, { token, newPassword });
            setMessage(response.data.message);
            setError('');
            setTimeout(()=>{
                navigation("/")
            },5000)
        } catch (error) {
            setError(error.response?.data?.message || 'Something went wrong');
            setMessage('');
        }
    };

    return (
        <Container maxWidth="sm" style={{ marginTop: '50px' }}>
            <Paper elevation={3} style={{ padding: '30px', textAlign: 'center' }}>
                <Typography variant="h4" gutterBottom>Reset Password</Typography>
                <TextField 
                    type='password' 
                    label='New Password' 
                    variant='outlined' 
                    fullWidth 
                    value={newPassword} 
                    onChange={(e) => setNewPassword(e.target.value)} 
                    margin='normal' 
                />
                <Button 
                    variant='contained' 
                    color='primary' 
                    fullWidth 
                    onClick={handleResetPassword}
                    style={{ marginTop: '20px' }}
                >
                    Reset Password
                </Button>
                {message && <Alert severity="success" style={{ marginTop: '20px' }}>{message}</Alert>}
                {error && <Alert severity="error" style={{ marginTop: '20px' }}>{error}</Alert>}
            </Paper>
        </Container>
    );
};

export default ResetPasswordScreen;
